import React, { useEffect } from 'react';
import { useTrustyActor, useTrustyState } from '../TrustyProvider';
import { trustyConstants as c } from '../../lib/trusty.constants';
import { HoldButton, Odometer } from '../../../../shared/ui';
import css from './TrustyUI.module.css';

export const UIPlaying = () => {
    const { send } = useTrustyActor();
    const state = useTrustyState();
    
    const {
        score, 
        timer, 
        streak, 
        scoreFeedback,
        timerFeedback
    } = state.context;

    useEffect(() => {
        const handleKeyDown = (event) => {
            const key = event.key.toLowerCase();
            if (key === 'arrowleft') {
                send({ type: c.events.GUESS, guess: false });
            } else if (key === 'arrowright') {
                send({ type: c.events.GUESS, guess: true });
            } else if (key === 'p' || key === 'з') {
                send({ type: c.events.PAUSE });
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [send]);

    return (
        <div className={css.playingUI}>
            <div className={css.header}>
                <div className={`${css.timer} ${timerFeedback ? css[timerFeedback] : ""}`}>
                    <span className={css.label}>Час:</span>
                    <Odometer number={timer} />
                </div>
                <div className={`${css.score} ${scoreFeedback ? css[scoreFeedback] : ""}`}>
                    <span className={css.label}>Бали:</span>
                    <Odometer number={score} />
                </div>
            </div>

            <div className={css.streakContainer}>
                {streak >= 3 && <div className={css.streak}>Streak: x{streak} 🔥</div>}
            </div>

            <div className={css.controls}>
                <HoldButton 
                    onAction={() => send({ type: c.events.GUESS, guess: false })} 
                    className={`${css.gameBtn} ${css.falseBtn}`}
                >
                    FALSE
                </HoldButton>

                <HoldButton 
                    onAction={() => send({ type: c.events.GUESS, guess: true })} 
                    className={`${css.gameBtn} ${css.trueBtn}`}
                >
                    TRUE
                </HoldButton>
            </div>
        </div>
    );
};
